module.exports = __webpack_public_path__ + "static/media/background6.ac5cc103.png";